export const AUTH_TOKEN = 'auth_token'

export const ACCESS_TOKEN = 'access_token'
export const USER_EMAIL = 'user_email'
export const USERNAME = 'username'
export const USER_ROLES = 'user_roles'
export const AUTH_EXPIRES_IN = 'auth_expires_in'
export const REFRESH_TOKEN = 'refresh_token'
